<template>
  <a href="#" class="cookie-settings-link" @click.prevent="open">Cookie settings</a>
</template>

<script>
import { EventBus } from "@/event-bus";

// Reopens the cookie banner (CookieBanner.vue), so a visitor can change or
// withdraw their choice as easily as they gave it.
export default {
  name: "CookieSettingsLink",
  methods: {
    open() {
      EventBus.$emit("open-cookie-banner");
    },
  },
};
</script>
